import React, { Component }     from "react";
import { Button, PageHeader, DropdownButton, FormControl, FormGroup, InputGroup, MenuItem, Panel, Row,Tab, Tabs, Col } from "react-bootstrap";
import { FontAwesomeIcon }      from '@fortawesome/react-fontawesome'
import BootstrapTable           from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ModalCreateFolder        from "../../components/modal/ModalCreateFolder";
import ModalMoveProgramToFolder from "../../components/modal/ModalMoveProgramToFolder";
import ModalAlert               from "../../components/modal/ModalAlert";
import ModalClientExerciseDetails     from "../../components/modal/ModalClientExerciseDetails";
import uniqueId                 from 'lodash/uniqueId';
import config                   from "../../config";
import RenderLander             from "../../components/utils/RenderLander";
import { Colors }               from "../../utils/Colors";
import ModalTrainerTextMsg      from "../../components/modal/ModalTrainerTextMsg";
import { invokeClientExerciseHistory,
         invokeGetClientsListAll }   from "../../utils/AwsInvoke";
import { doesTrainerHaveValidPhoneNumber } from "../../utils/CheckIfValidPhoneNumber";
import "../../css/client/TableClientExerciseHistory.css";

const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    hideSelectColumn: false,
    bgColor: "#fff"
};

var member_list_arr     = [];

//  ALL HTML tags MUST be removed for the SORT feature to work on a table  //
const columns_prog = [{
    dataField: "member_name",
    text: "sort",
    sort: true,
    filter: textFilter({
        placeholder: 'Filter by Name',
        //defaultValue: 'test', // default filtering value
        delay: 0,
        style: { position: "relative", left:20, width: 300 },
    }),
    headerStyle: () => {
        return { width: "75%", textAlign: "center", color: "#666", outline: 0, border: 0 };
    }
/* {
    dataField: "link",
    text: "History",
    headerStyle: () => {
        return { width: "15%", textAlign: "center" };
    }
/*},{
    dataField: "date_created",
    text: "Date",
    headerStyle: () => {
        return { width: "15%", textAlign: "center" };
    }*/
}];


export default class TableProgramListAllClients extends Component {
    constructor(props) {
        super(props);

        this.state = {
          isLoading: true,
          search_term: "",
          showModalClientExerciseDetails: false,
          companyId: this.props.companyId
        };
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            this.getClientsListAll ();
        } catch (e) {
            alert(e);
        }
    }


    getClientsListAll = async () => {
        var search_term = ""; // & = "search everything" //this.state.searchTerm;
        var sort_by     = 1;
        var number_of_rows;
        var company_id  = this.state.companyId;

        //if(this.searchInput != undefined)
        //    search_str = this.searchInput.value;

        const results = await invokeGetClientsListAll(number_of_rows, sort_by, company_id, search_term.toLowerCase());

        if(results) {
            this.setState({
                members: results, //resultsExerciseHistory
                totalMembers: results.search_lgth,
                isLoading: false,
                showLoadingBar: "none"
            });
        } else
            this.setState({ isLoading: false, showLoadingBar: "none" })

        /*this.setState({
            searchTerm: search_str
        }, async function() {
            const resultsExerciseHistory = await invokeClientExerciseHistory(client_id, search_str.toLowerCase());

            this.setState({
                 resultsExerciseHistory: resultsExerciseHistory.data,
            }, function() {
                //this.renderMembers();
            })
        })*/
    }

    // Show Exercise Detail Modal
    handleViewExercise = (member_id, name) => {
        this.setState({
            showModalClientExerciseDetails: true,
            memberId:   member_id,
            exerciseName: name
        })
    }

    renderMembers = (members) => {
        var total_members = this.state.totalMembers;
        member_list_arr = []; // reset old data cached in array
        for(var t = 0; t < total_members; t++) {

            var name       = members.first_name[t] + " " + members.last_name[t];
            var member_id  = members.id[t];

            if(name != null) {
                    member_list_arr.push({
                          id: uniqueId(), // id is required for unique keys, otherwise there's an error
                          member_name: name,
                          /*link:         <span style = {{position:"relative",left:"40%", cursor: "pointer"}}
                                              onClick={this.handleViewExercise.bind(this,member_id, name)}>
                                              <FontAwesomeIcon key={uniqueId()} icon="heartbeat" style={{fontSize:22}}/>
                                        </span>,*/
                          //date_created: <span key={uniqueId()}>{ new_date}</span>
                    })
            }
        }
    }

    ////   SHOW THE ALERT MODAL   ////
    /*setModalClientExerciseDetailsProps = (title_text, program_id) => {
        this.setState({
            modalTitleText: title_text,
            modalProgramId:  program_id,
            showModalClientExerciseDetails:  true, // true | false
        })
    }*/

    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }


    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13)
            this.getClientsListAll();
    }

    clearSearchField = () => {
        // RESET URL
        //this.props.history.replace("/exercise/listAll/&")

        this.setState({
            searchTerm: "", // reset search term if resetting exerc list
            searchMsg: ""
        }, function () {
            this.getClientsListAll(); // reload list after deleting search term
        })
    }

    renderHome() {
        var exercise_saved;
        var members = this.state.members;
        this.renderMembers(members);

        return (
              <div className="programs">
                    { /*}<div className="clientExerciseHistoryHeaderSearchBar">
                            <span>
                                  <FormGroup>
                                     <InputGroup>
                                       <FormControl key = {uniqueId()}
                                                    type="text"
                                                    placeholder=""
                                                    defaultValue={this.state.searchTerm}
                                                    inputRef={ref => { this.searchInput = ref; }}
                                                    onKeyPress={this.handleKeyPress}
                                                />

                                         <span className="glyphicon glyphicon-remove-circle searchInputClearBtn"
                                               onClick={() => this.clearSearchField()}
                                         />
                                         <InputGroup.Button>
                                           <Button style={{ display:"inline-block", height:"34px",backgroundColor: Colors.search_button_bg, color:"white", borderRadiusInputTopRight: "5px" }} onClick={() => this.getClientsListAll()}>Search</Button>
                                         </InputGroup.Button>
                                     </InputGroup>
                                   </FormGroup>
                            </span>
                    </div>*/ }
                    <BootstrapTable keyField  = "id"
                                    key       = {uniqueId()}
                                    data      = { member_list_arr }
                                    columns   = { columns_prog }
                                    striped hover
                                    selectRow = { selectRow }
                                    filter    = { filterFactory()}
                                    />
              </div>
        );
    }

    render() {
        let closeModalAlert           = () => this.setState({ showModalAlert: false }); //close simple modal window
        let closeModalClientExerciseDetails = () => this.setState({ showModalClientExerciseDetails: false }); //close simple modal window

        return (
              <div className="Home">
                {this.renderHome()}

                  { /*this.state.showModalAlert ?
                      <ModalAlert
                          onHide         = {closeModalAlert}
                          alertFunction  = {this.alertFunction}     // custom function to call within modal
                          alertAction    = {this.state.alertAction} // flag used for above function
                          alertObject    = {this.state.alertObject} // vars used for above function
                          showModalAlert = {this.state.showModalAlert}
                          messageTitle   = {this.state.modalAlertTitleText}
                          messageBody    = {this.state.modalAlertBodyText}
                      />
                  : null}
                  {this.state.showModalClientExerciseDetails ?
                      <ModalClientExerciseDetails
                          onHide         = {closeModalClientExerciseDetails}
                          clientId       = {this.state.clientId}
                          exerciseName   = {this.state.exerciseName}
                          exerciseId     = {this.state.exerciseId}
                          showModalClientExerciseDetails = {this.state.showModalClientExerciseDetails}
                          modalProgramId = {this.state.modalProgramId}
                      />
                  : null */ }
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/components/program/TableProgramListAllClients.js